import * as components from '@components/convenia-components/index.js'
import * as directives from '@/directives/index.js'
import Table from 'vue-data-tablee'

/**
 * Implementa os componentes no Vue.
 * @example ```
 * import Vue from 'vue'
 * import VueConveniaComponents from 'vue-convenia-components'
 *
 * Vue.use(VueConveniaComponents)
 * ```
 * @param {Vue} Vue
 */
const install = (Vue) => {
  Object.entries(components).forEach(([name, component]) => {
    Vue.component(name, component)
  })

  Vue.use(Table, { name: 'c-table' })

  Object.entries(directives).forEach(([name, directive]) => {
    Vue.directive(name, directive)
  })
}

export * from '@components/convenia-components/index.js'

export default install



// WEBPACK FOOTER //
// ./src/vue-convenia-components.js